/* eslint-disable prettier/prettier */

export const ZERO_TAGLINES = [
    'Enjoy your day!',
    'Take a moment for yourself',
    'Time to enjoy a nice cup of coffee',
    'Enjoy your favourite playlist',
    "Let's go outside",
    'Play time!',
]
